import ISelectionMap from "@ogaf/map.scripts/Interfaces/ISelectionMap";
import SelectionMap from "@ogaf/map.scripts/MapTypes/SelectionMap";
import { TTrateTask } from "../Tasks/PopisSite/Trate/TrateTask";

/**
 * Třída pro mapovou verzi predikce výluk
 */
export default class TrateSelectionMap extends SelectionMap {
    /**
     * Vrstva, která je aktuálně zaměřena
     */
    FocusedLayer: string;

    /**
     * kontruktor třídy TrateSelectionMap
     * @param fmap
     */
    constructor(fmap: ISelectionMap) {
        super(fmap);
        this.Coherence = "Coherent";
    }

    /**
     * Načítá správní ribbon
     */
    public async CorrectRibbon(): Promise<void> {
        const url = `${this.UrlPath}CorrectRibbon`;
        const fetched = fetch(`${url}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: null
        });
        const res = await fetched;
        const resJson = await res.text();

        $(".mainRibbonGroupContainer").append(resJson);
        globalThis.CurrentTask.App.hideLoadingPanel();
    }

    /**
     * přepsaná metoda na získání bodů a hran sítě
     */
    public override async GetNetData(): Promise<void> {
        await super.GetNetData();
        
        this.GetConnectedPoints();
    }

    /**
     * přepsaná metoda na získání nejkratší cesty
     */
    public override GetShortestRoute(pointFrom: number, pointTo: number): number {
        this.GetConnectedPoints();

        const paths = new Map<number, { PointId: number, PrevPointId: number, EdgeId: number, Distance: number }>();
        const visited = new Set<number>();

        paths.set(pointFrom, { PointId: pointFrom, PrevPointId: pointFrom, EdgeId: 0, Distance: 0 });

        while (visited.size < this.ConnectedPoints.size) {
            let current: number | null = null;
            let minDistance = Infinity;

            for (const [pointId, pathData] of paths) {
                if (!visited.has(pointId) && pathData.Distance < minDistance) {
                    current = pointId;
                    minDistance = pathData.Distance;
                }
            }

            if (current === null || current === pointTo) break;

            visited.add(current); // Označí bod jako zpracovaný

            const currentPath = paths.get(current)!;
            const connectedPoints = this.ConnectedPoints.get(current);

            if (!connectedPoints) continue;

            // Zkontroluje všechny sousední body
            for (const neighbor of connectedPoints) {
                if (visited.has(neighbor)) continue;

                // Najde hranu mezi aktuálním bodem a sousedem
                const edge = this.Edges.find((e: any) =>
                    (e.Point1 === current && e.Point2 === neighbor) ||
                    (e.Point2 === current && e.Point1 === neighbor)
                );

                if (!edge) continue;

                const newDistance = currentPath.Distance + edge.Length;
                const existingPath = paths.get(neighbor);

                if (!existingPath || newDistance < existingPath.Distance) {
                    paths.set(neighbor, {
                        PointId: neighbor,
                        PrevPointId: current,
                        EdgeId: edge.Id,
                        Distance: newDistance
                    });
                }
            }
        }

        // Zkontroluje, zda cesta existuje
        if (!paths.has(pointTo)) return 0;

        const pointsPath: number[] = [];
        const edgesPath: number[] = [];
        let current = pointTo;

        while (current !== pointFrom) {
            pointsPath.push(current);
            const pathData = paths.get(current);
            if (!pathData) {
                console.error("Nelze spojit:", current);
                return 0;
            }
            edgesPath.push(pathData.EdgeId);
            current = pathData.PrevPointId;
        }

        // Otočí, aby cesta vedla od zdroje k cíli
        pointsPath.reverse();
        edgesPath.reverse();

        if (this.ActiveLayer === 'Points') {
            for (const p of pointsPath) {
                if (!this.SelectedPoints.includes(p)) {
                    this.SetPointSelected(p);
                }
            }
        }
        else {
            if (this.SelectedPoints.length >= 1) {
                this.ClearPointsSelections();
            } else if (this.SelectedPoints.length === 0) {
                this.SetPointSelected(pointsPath[0]);
            }
            for (const e of edgesPath) {
                if (!this.SelectedEdges.includes(e)) {
                    this.SetEdgeSelected(e);
                }
            }
            this.SetPointSelected(pointsPath[pointsPath.length - 1]);
        }

        // Vrátí celkovou délku nejkratší cesty
        return paths.get(pointTo)!.Distance;
    }

    /**
     * přepsaná metoda na inicializaci mapy
     */
    public override AfterInitCalls(): void {
        $('[onclick="CurrentTask.App.OnRibbonTabItemAction(\'fnClear\')"]').removeAttr("onclick").attr("onclick", "OGMap.ClearSelections()");
    }

    /**
     * přepsaná metoda na point klik v mapě
     * @param id id bodu
     * @param e
     * @param additionalParams pole dalších hodnot z mapové implementace
     * @returns
     */
    public override OnPointClick(id: number, e: MouseEvent, additionalParams?: any[]): void {
        (CurrentTask as TTrateTask).EmptyFocusAndClearSelection();

        const layerType = "Point";

        if (!this.SelectedPoints.includes(id)) {
            return;
        }

        if (this.FocusedLayer == layerType + "-" + id) {
            this.FocusedLayer = "";
            return;
        } else {
            void this.FocusLayer(layerType, id);
        }
    }

    /**
     * přepsaná metoda na edge klik v mapě
     * @param id id hrany
     * @param e
     * @param additionalParams pole dalších hodnot z mapové implementace
     * @returns
     */
    public override OnEdgeClick(id: number, e: MouseEvent, additionalParams?: any[]): void {
        (CurrentTask as TTrateTask).EmptyFocusAndClearSelection();

        const layerType = "Edge";

        if (!this.SelectedEdges.includes(id)) {
            return;
        }

        if (this.FocusedLayer == layerType + "-" + id) {
            this.FocusedLayer = "";
            return;
        }

        void this.FocusLayer(layerType, id);
    }
    /**
     * přepsaná metoda na dvojklik na bod v mapě    
     * @param id
     * @param e
     * @param additionalParams
     */
    public override OnPointDblClick(id: number, e: MouseEvent, additionalParams?: any[]): void { }

    /**     
     * přepsaná metoda na najetí myší na bod v mapě
     * @param id
     * @param e
     * @param additionalParams
     */
    public override OnPointMouseOver(id: number, e: MouseEvent, additionalParams?: any[]): void { }

    /**     
     * přepsaná metoda na opuštění bodu myší v mapě
     * @param id
     * @param e
     * @param additionalParams
     */
    public override OnPointMouseOut(id: number, e: MouseEvent, additionalParams?: any[]): void { }

    /**     
     * přepsaná metoda na najetí myší na hranu v mapě 
     * @param id
     * @param e
     * @param additionalParams
     */
    public override OnEdgeMouseOver(id: number, e: MouseEvent, additionalParams?: any[]): void { }

    /**
     * přepsaná metoda opuštění myší hrany v mapě
     * @param id
     * @param e
     * @param additionalParams
     */
    public override OnEdgeMouseOut(id: number, e: MouseEvent, additionalParams?: any[]): void { }

    /**
     * přepsaná metoda OnMapKeyDown
     * @param id
     * @param e
     * @param additionalParams
     */
    public override OnMapKeyDown(id: number, e: KeyboardEvent, additionalParams?: any[]): void { }

    /**
     * přepsaná metoda OnMapKeyUp
     * @param id
     * @param e
     * @param additionalParams
     */
    public override OnMapKeyUp(id: number, e: KeyboardEvent, additionalParams?: any[]): void { }

    /**
     * přidává bod/hranu do focus vrstvy a označí v gridu
     * @param type typ "Edge" / "Point"
     * @param id id bodu/hrany
     */
    public async FocusLayer(type: string, id: number): Promise<void> {
        this.FocusedLayer = type + "-" + id;
        this.FMap.SetFocus(id, type);

        if (type == "Edge") {
            const edge = this.GetEdgeWithId(id);

            await (CurrentTask as TTrateTask).SelectGridRow(edge.Point1);
            await (CurrentTask as TTrateTask).SelectGridRow(edge.Point2, false);
        } else {
            await (CurrentTask as TTrateTask).SelectGridRow(id);
        }
    }
}